<template>
  <div class="tab-pane fade" id="cross-center" role="tabpanel" aria-labelledby="cross-center-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-lg-5 col-md-7">
          <label for="inputEmail4" class="form-label">遊客中心</label><br>
          <select id="selectCenterArea" class="selectpicker" v-model.number="selectScenicAreas" multiple>
            <option :value="selectAll">全部</option>
            <option v-for="(list, index) in peopleAnalysisScenicArea" :key="index" :value="list">{{ list.name }}</option>
          </select>
        </div>

        <div class="col-md-6 col-lg-3">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 col-lg-3">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk" :disabled="isWaitCCTVList">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV" :disabled="isWaitCCTVList"> 
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">跨景區比較</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-flex g-2">
        <div class="col order-2 order-md-1">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="crossCenter" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">時間</th>
                    <th scope="col">遊客中心</th>
                    <!-- <th scope="col">在園人數</th> -->
                    <th scope="col">進場人數</th>
                    <!-- <th scope="col">離場人數</th>                     -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in peopleCountDataList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.time }}</td>
                    <td>{{ item.areaName}}</td>
                    <!-- <td>{{ item.peopleStay }}</td> -->
                    <td>{{ item.peopleIn}}</td>
                    <!-- <td>{{ item.peopleOut }}</td> -->
                  </tr>      
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div class="col order-1  order-md-2">
          <div id="sumCenterPeopleChart">
                      <apexchart
                        type="bar"
                        height="200"
                        :options="sumPeopleFlowSetting"
                        :series="sumPeopleFlowData"
                      ></apexchart>
          </div>
        </div>
      </div>

    </div>
  </div>
    

  
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'
import { getCountPerDay } from "../../api/elasticSearch/peopleApis";
import { postCentralPeopleFlow } from '../../api/eastCoastDataApi/ElkQuery/PeopleFlowElk'
import ApexchartObject from '../../utils/apexchartObject/centerPeopleFlow'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      selectAll: CONST.MULTI_SELECT_ALL,
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      selectScenicAreas: [],
      peopleCountDataList: [],
      isWaitCCTVList: false,
      sumPeopleFlowData:[],
      sumPeopleFlowSetting: {...ApexchartObject.crossCenterOption},
      maxSelectTime: moment().startOf('m').toISOString(),

    };
  },
  watch: {
    async selectScenicAreaId() {
      // this.isWaitCCTVList = true
      // await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
      // this.selectDeviceId = "-1"
      // this.isWaitCCTVList = false
    },
    peopleAnalysisScenicArea(){
      this.$nextTick(() => {
      // 確保DOM更新後再次刷新selectpicker
      $('#selectCenterArea').selectpicker({
        noneSelectedText: '請選擇'
         });
      })
    },
    selectScenicAreas: {
     handler(newValue, oldValue){
       if(newValue[0] === CONST.MULTI_SELECT_ALL&& oldValue [0] !== CONST.MULTI_SELECT_ALL){
        //表示若已有選擇其他景區，再選擇全部的情況
         $('#selectCenterArea').selectpicker('selectAll');
       }
       
       if(newValue[0] !== CONST.MULTI_SELECT_ALL&& oldValue [0] === CONST.MULTI_SELECT_ALL){
         //表示取消全部選擇的情況
         
         $('#selectCenterArea').selectpicker('deselectAll');
         this.selectScenicAreas = [];
        }
        if(oldValue[0] === CONST.MULTI_SELECT_ALL && newValue.length < oldValue.length ){
          // console.log("從選擇全部中移除部分景區")
          //表示選擇全部，但是未全選
          
          //表示從全選狀態離開，產生非全選的狀態，移除陣列this.selectScenicAreas的[0](selectAll)
          this.selectScenicAreas.shift();
        }}
    }
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    // ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),

     peopleAnalysisScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE))
    },

    searchTime() {
      return `${moment(this.startTime).format('YYYY/MM/DD HH:mm')}~${moment(this.endTime).format('YYYY/MM/DD HH:mm')}`
    },
  },
  methods: {
    async queryCSV() {
      this.isWaitCCTVList = true
      
      const dataList = await this.searchELK();
      if(Utils.isEmptyObject(dataList)) {
        alert('沒有資料')
        return
      }

      const csvContent = [['時間', '遊客中心', '進場人數']]
      dataList.forEach(item => {
        const row = []
        row.push(item.time)
        row.push(item.areaName)
        // row.push(item.peopleStay)
        row.push(item.peopleIn)
        // row.push(item.peopleOut)

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_遊客人數統計.csv`
      exportCSV.genCSVFile(csvContent, fileName)
      this.isWaitCCTVList = false
    },

    async queryElk () {
      this.isWaitCCTVList = true  

      const dataList = await this.searchELK();
      this.peopleCountDataList = dataList
      this.setChartData(this.peopleCountDataList)
      this.updateTable()
      this.isWaitCCTVList = false
    },

    async searchELK() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      const condition = {
        areas:[],
        sttime: moment(this.startTime).startOf('minute').format(),
        endtime: moment(this.endTime).startOf('minute').format(),
        interval: "day"
      }

      if(this.selectScenicAreas.length === 0 || this.selectScenicAreas[0] === CONST.MULTI_SELECT_ALL) {
        condition.areas = this.peopleAnalysisScenicArea.map(sc => sc.id) // 預設全選 
      } else {
        condition.areas = this.selectScenicAreas.map(sc => sc.id)
      }
      
      const result = await postCentralPeopleFlow(condition)
      if(!result.success){
        return []
      }

      const total = {
        time: '統計',
        areaName: '',
        peopleIn: 0,
        peopleOut: 0,
        peopleStay: 0
      }

      const dataList = result.data.map(e => {
        const data ={}
        data.areaName = e.areaName
        data.time = `${moment(e.dateTime).format('YYYY-MM-DD')}`
        data.peopleIn = e.peopleIn
        data.peopleOut = e.peopleOut
        data.peopleStay = e.peopleStay

        total.peopleIn = total.peopleIn + data.peopleIn
        total.peopleOut = total.peopleOut + data.peopleOut
        total.peopleStay = total.peopleStay + data.peopleStay

        return data
      })

      dataList.push(total)
      return dataList

    },

    setChartData(dataList) {
      const list = dataList.slice(0, -1); //移除最後一個統計元素，產生新陣列
      const sumList = Object.values(list.reduce((acc, obj) => {
        //將相同遊客中心的人數相加
        if (acc[obj.areaName]) {
          acc[obj.areaName].peopleStay += obj.peopleStay;
          acc[obj.areaName].peopleIn += obj.peopleIn;
          acc[obj.areaName].peopleOut += obj.peopleOut;
        } else {
          acc[obj.areaName] = { ...obj };
        }
        return acc;
      }, {}));

      this.sumPeopleFlowData = []
      const peopleStayCount = sumList.map((d, i) => {
        return d.peopleStay
      })

      const peopleInCount = sumList.map((d, i) => {
        return d.peopleIn
      })

      const peopleOutCount = sumList.map((d, i) => {
        return d.peopleOut
      })

      // this.sumPeopleFlowData.push({name: '在園人數', data: peopleStayCount})
      this.sumPeopleFlowData.push({name: '進場人數', data: peopleInCount})
      // this.sumPeopleFlowData.push({name: '離場人數', data: peopleOutCount})   

      let chartSetting = {...this.sumPeopleFlowSetting}
      const xaxisCategories = sumList.map((d, i) => {
        return d.areaName
      })
      chartSetting = {...chartSetting, ...{xaxis:{categories: xaxisCategories}}} //https://github.com/apexcharts/vue-apexcharts/issues/74#issuecomment-472717678

      chartSetting.chart.toolbar.export={
              csv: {
                filename: `跨景區_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              },
              svg: {
                filename: `跨景區_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              },
              png: {
                filename: `跨景區_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              }
            }

      this.sumPeopleFlowSetting = {...chartSetting} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.time)) {
        return "-";
      }

      const time = moment(item.time)
      return `${time.format('YYYY/MM/DD')}`
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    initTable: function () {
      this.table = $("#crossCenter").DataTable({
        aoColumns: [
          ...new Array($("#crossCenter th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 10,
      });
    },

    updateTable() {
      if(!Utils.isEmptyObject(this.table)){
        this.table.destroy()
      }
      
      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable();
    setTimeout(() => {
        $('#selectCenterArea').selectpicker({
        noneSelectedText: '請選擇'
         });
      }, 500);
    
  }
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>
